import React from 'react';
import styled from '@emotion/styled';
import Paper from '@base/Paper/Paper';
import BreadCrumbs from '@base/BreadCrumbs/BreadCrumbs';
import H2 from '@base/H2/H2';
import breadcrumbs from '@utils/breadcrumbs';
import { Spacings, mediaQuery, Fonts } from '@styles/index';
import { PlusTopologySource } from '@constants/index';
import pushRoute from '@utils/pushRoute';
import { useRouter } from 'next/router';
import useGoalInfo from '@api/hooks/goal/useGoalInfo';
import { useSelector } from 'react-redux';
import { getIsSubscribedToOffline } from '@selectors/subscription';
import plusNavBarItems from '@layout/NavBar/PlusNavBar/plusNavBarItems';

const HeaderNavBar = styled(Paper)`
  margin-bottom: ${Spacings.SPACING_10B};
  border-radius: ${Spacings.SPACING_2B};
  padding: ${Spacings.SPACING_8B} ${Spacings.SPACING_12B};
  ${mediaQuery.uptoMobile} {
    background: var(--color-base-0);
    box-shadow: none;
    padding: ${Spacings.SPACING_6B} 0 0 0;
    margin-bottom: ${Spacings.SPACING_8B};
  }
`;

const Title = styled(H2)`
  margin-top: ${Spacings.SPACING_4B};
  font-weight: ${Fonts.BOLD};
  height: ${Spacings.SPACING_12B};
  line-height: 150%;
`;

const sourcesType = Object.keys(PlusTopologySource).map(
  (key) => PlusTopologySource[key]
);

export interface ISyllabusHomePageHeaderProps {
  source: typeof sourcesType;
  goalUID: string;
  isGTP: boolean;
}

const headerTags = (goalTopology, source, isGTP, isOfflineSubscription) => {
  const tags = [];
  if (goalTopology) {
    tags.push(
      ...breadcrumbs.getPlusTopicsTags(goalTopology, isOfflineSubscription)
    );
    if (source === PlusTopologySource.TOPIC_FEED) {
      tags.push(...breadcrumbs.getTopics(goalTopology, isGTP));
    }
  }
  return tags;
};

const Header: React.FC<ISyllabusHomePageHeaderProps> = ({
  source,
  goalUID,
  isGTP
}) => {
  // @ts-ignore
  const { goalInfo: goalTopology } = useGoalInfo(goalUID);
  const { isRecordedGoal } = goalTopology;
  const {
    query: { goalSlug }
  } = useRouter();
  const isOfflineSubscription = useSelector(getIsSubscribedToOffline(goalUID));

  const goBack = () => {
    pushRoute(
      '/goal/[goalSlug]/[goalUID]/planner',
      `/goal/${goalSlug}/${goalUID}/planner`
    );
  };

  return (
    <>
      {/** @ts-ignore */}
      <HeaderNavBar gridColumn="span 18">
        <BreadCrumbs
          tags={headerTags(goalTopology, source, isGTP, isOfflineSubscription)}
          onBackClick={goBack}
          useBackClick
        />
        <Title as="h1">
          {isGTP || isRecordedGoal ? 'Video lessons' : plusNavBarItems.PLAYLIST}
        </Title>
      </HeaderNavBar>
    </>
  );
};

const sources = Object.keys(PlusTopologySource).map(
  (key) => PlusTopologySource[key]
);

export default Header;
